import React from "react";
import { TbPlus, TbCheck } from "react-icons/tb";
import { CustomButton, CustomLoader } from "../../../../components";
import BillingSummary from "../BillingSummary";
import styles from "../Pricing.module.css";

const formatAmount = (value) => `₹${Number(value).toLocaleString("en-IN")}`;

const Step2AddOns = ({
  addOns,
  loading,
  error,
  selectedAddOnIds,
  onToggleAddOn,
  plan,
  slab,
  onBack,
  onNext,
}) => {
  // BUG-001: label changes based on whether any add-on is selected
  const primaryLabel =
    selectedAddOnIds.length > 0 ? "Proceed" : "Skip & Proceed";

  return (
    <div>
      <h2 className={`heading ${styles.stepHeading}`}>
        Customize Your Plan with{" "}
        <span className={styles.stepHeadingAccent}>Add-ons</span>
      </h2>
      <p className={styles.stepSubtitle}>
        Customize your plan with additional features and resources that fit your
        needs.
      </p>

      <div className={styles.stepLayout}>
        {loading && (
          <div className={styles.compareStateWrap}>
            <CustomLoader text="Loading add-ons..." />
          </div>
        )}

        {!loading && error && (
          <div className={styles.compareStateWrap}>
            <p className={styles.compareErrorText}>{error}</p>
          </div>
        )}

        {!loading && !error && (
          <div className={styles.addOnCardsGrid}>
            {addOns.map((addOn) => {
              const added = selectedAddOnIds.includes(addOn.id);
              return (
                <div key={addOn.id} className={styles.addOnCard}>
                  <div>
                    <span className={styles.addOnCardTitle}>{addOn.name}</span>
                    {/* ← add this */}
                    {addOn.description && (
                      <p className={styles.addOnCardDescription}>
                        {addOn.description}
                      </p>
                    )}
                  </div>
                  <div className={styles.addOnCardFooter}>
                    <span className={styles.addOnPriceTag}>
                      {formatAmount(addOn.price)}/year
                    </span>
                    {added ? (
                      <CustomButton
                        variant="primary"
                        fullWidth={false}
                        rounded
                        className={styles.addOnAddedBtn}
                        onClick={() => onToggleAddOn(addOn.id)}
                      >
                        <TbCheck /> Added
                      </CustomButton>
                    ) : (
                      <CustomButton
                        variant="outline-primary"
                        fullWidth={false}
                        rounded
                        className={styles.addOnAddBtn}
                        onClick={() => onToggleAddOn(addOn.id)}
                      >
                        <TbPlus /> Add
                      </CustomButton>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <BillingSummary
          plan={plan}
          slab={slab}
          addOns={addOns}
          selectedAddOnIds={selectedAddOnIds}
          primaryLabel={primaryLabel}
          onPrimary={onNext}
          secondaryLabel="Back to Select Plan"
          onSecondary={onBack}
        />
      </div>
    </div>
  );
};

export default Step2AddOns;
